import React from 'react';
import LegalPage, { LegalList, LegalListItem, LegalSection } from './LegalPage';

export default function TermsOfUse() {
  return (
    <LegalPage title="WOHNRECHNER NUTZUNGSBEDINGUNGEN">
      <p>
        Beim <strong>Wohnrechner</strong> handelt es sich um eine von der{' '}
        <strong>HYPO NOE Landesbank für Niederösterreich und Wien AG</strong> („Verantwortlichen“ oder “HYPO NOE”) zur
        Verfügung gestellte Plattform (die „Plattform“), über die Nutzer in wenigen Schritten
      </p>
      <LegalList>
        <LegalListItem>einen Richtwert für die Kosten des geplanten Immobilienprojekts bekommen,</LegalListItem>
        <LegalListItem>ihr Haushaltsbudget berechnen können,</LegalListItem>
        <LegalListItem>einen Überblick über die Finanzierbarkeit ihrer geplanten Immobilie bekommen und</LegalListItem>
        <LegalListItem>den Schätzwert der Wunschimmobilie ermitteln können.</LegalListItem>
      </LegalList>
      <p>Für den Zugang zu und die Nutzung des Wohnrechners gelten die folgenden Bedingungen:</p>

      <LegalSection title="ALLGEMEINES">
        <LegalList ordered>
          <LegalListItem>
            Die angegebenen Werte der Projektkostenermittlung sind unverbindliche Schätzwerte, die aufgrund
            marktüblicher Durchschnittswerte in Österreich berechnet wurden und ausschließlich zu Ihrer
            Orientierungshilfe dienen. Bedenken Sie bitte, dass diese Werte je nach Marktlage, Verhandlungssituation und
            Ausführung mehr oder weniger von den tatsächlichen Werten abweichen können.
          </LegalListItem>
          <LegalListItem>
            Die HYPO NOE übernimmt keine Haftung für die Richtigkeit dieser Werte, ebenso wenig wie für allfällige
            Fehlfunktionen der Plattform.
          </LegalListItem>
          <LegalListItem>
            Die HYPO NOE empfiehlt Ihnen keinen bestimmten Kredit. Aufgrund Ihrer Antworten auf einige der Fragen
            erhalten Sie von der HYPO NOE jedoch Informationen über Finanzierungen, damit Sie Ihre eigene Entscheidung
            treffen können. Die vorliegende Aufstellung stellt kein Angebot im Rechtssinn dar, sondern dient
            ausschließlich zur internen Bearbeitung des Kreditwunsches.
          </LegalListItem>
          <LegalListItem>
            Die Ergebnisse der Finanzierungs- und Haushaltsrechnung werden aufgrund Ihrer Eingaben berechnet, dienen
            ausschließlich als Orientierungshilfe und stellen kein verbindliches Angebot dar.
          </LegalListItem>
        </LegalList>
        <p>
          Die HYPO NOE ist bereit Ihnen im Falle eines konkreten Interesses ein persönliches unverbindliches Angebot
          gemäß Hypothekar- und Immobilienkreditgesetz (HIKrG) zu erstellen. Die Konditionen der Finanzierung sind ua
          abhängig von Bonität, Volumen, Laufzeit, Verwendungszweck und Besicherung. Bitte nutzen Sie dafür die Option
          &quot;Persönliches Angebot anfordern&quot; und einer unserer Wohnbauexperten wird sich diesbezüglich mit Ihnen
          in Verbindung setzen.
        </p>
      </LegalSection>

      <LegalSection title="NUTZUNG DER PLATTFORM">
        <LegalList ordered start={5}>
          <LegalListItem>
            Der Zugriff auf die Plattform und die Nutzung des Service ist kostenlos und je Nutzer (d.h. je E-Mailadresse
            und IP-Adresse) mit 3 Bewertungen pro Tag und 10 Bewertungen pro Monat limitiert. Automatisierte Abfragen,
            Spam-Abfragen bzw. systematische Abfragen sowie die Umgehung der oben genannten zahlenmäßigen
            Zugriffsbeschränkung sind unzulässig.
          </LegalListItem>
          <LegalListItem>
            Der Zugang zu und die Nutzung der Plattform setzen die vollständige und zutreffende Angabe der
            erforderlichen Objekt- und Kontaktdaten voraus. Voraussetzung der Nutzung ist weiters, dass die
            gegenständlichen Nutzungsbedingungen akzeptiert und laufend beachtet werden.
          </LegalListItem>
          <LegalListItem>
            Die Plattform erlaubt es Nutzern, eine Wertermittlung für in Österreich gelegene Immobilien vorzunehmen.
            Dazu gibt der Nutzer die Adresse der zu bewertenden Immobilie, einige wichtige Objekteigenschaften wie
            Grundstücks- und/oder Wohnfläche, Stockwerkslage, sonstige Ausstattungsmerkmale (Balkon, Terrasse, Loggia,
            Keller, Garage, Aufzug) sowie Baujahr und Gebäudezustand ein und erhält eine E-Mail mit einem Link, über den
            das Bewertungsergebnis abgerufen und in ein Dokument exportiert werden kann („Ergebnisdokument“).
          </LegalListItem>
          <LegalListItem>Die Wertermittlung erfolgt in Kooperation mit der Sprengnetter GmbH („DSS“),</LegalListItem>
          <LegalListItem>
            Im Wohnrechner erfolgt eine reine Online-Wertermittlung der Immobilie auf Basis der Angaben des Nutzers in
            der entsprechenden Suchmaske. Der Verantwortlichen hat keine Möglichkeit, diese Angaben zu überprüfen. Es
            wird ausdrücklich darauf hingewiesen, dass die dem Nutzer aufgrund seiner Anfrage zur Verfügung gestellten
            Vergleichsdaten und Informationen ausschließlich auf den verfügbaren und für diese Zwecke verwendbaren
            Vergleichsdaten beruhen. Eine Besichtigung der Objekte oder der Lage und Umgebung derselben durch den
            Verantwortlichen ist nicht erfolgt. Der ausgewiesene Wert kann zudem von weiteren Faktoren abhängig sein,
            die im Rahmen einer Erstanalyse auf der Plattform nicht oder nicht vollständig berücksichtigt werden können;
            dies beinhaltet insbesondere, aber nicht ausschließlich, Baumängel oder -schäden, ungewöhnliche
            Ausstattungsmerkmale, schlechte Raumkonfigurationen etc. Ebenfalls unberücksichtigt bleiben allfällige
            bücherliche oder außerbücherliche Lasten (Pfandrechte, Wohnrechte, Fruchtgenussrechte, Belastungs- und
            Veräußerungsverbote etc.), das (Nicht-) Vorliegen baubehördlicher Genehmigungen, Fragen der widmungsgemäßen
            oder sonst rechtmäßigen Nutzung des Objekts. Für das Ergebnisdokument wird grundsätzlich von einer
            ordnungsgemäßen, rechts- und bescheidkonformen Errichtung und Nutzung ausgegangen. Die Bewertung erfolgt im
            Vergleichswertverfahren unter Berücksichtigung der Preise für vergleichbare Grundstücke und Baulichkeiten
            sowie der besonderen Verhältnisse. Zugrunde gelegt werden die Adressen, Ausstattungsmerkmale und Preise wie
            in den verwendeten Datengrundlagen angegeben und mit technischen Verfahren ergänzt. Dabei werden
            grundbücherliche Kaufpreise sowie darüber hinaus auch Daten und Preise von Immobilienangeboten verwendet und
            mit technischen Methoden zusammengeführt und plausibilisiert. Mithilfe statistischer Verfahren werden
            Korrekturfaktoren ermittelt, die zur Ermittlung der Vergleichswerte angewendet werden. Insbesondere wird
            auch Bedacht genommen auf die Lage und Ausstattung. Der Erhaltungszustand des Bewertungsobjektes muss vom
            Nutzer im Rahmen des Lokalaugenscheines festgestellt und klassifiziert werden. Eine über die
            Eingabemöglichkeiten auf der Plattform hinausgehende Wertanpassung, ist nicht möglich. Es wird darauf
            hingewiesen, dass der tatsächlich erzielbare Verkaufswert erfahrungsgemäß innerhalb einer Streuung von +/-
            15 % des errechneten Wertes liegt, wobei diese Streuung vom Nutzer nicht beeinflusst werden kann und unter
            Anderem davon abhängig ist, ob ein zeitnaher Verkauf erforderlich ist oder dafür mehr Zeit zur Verfügung
            steht (auf Punkt 13 wird ausdrücklich verwiesen).
          </LegalListItem>
          <LegalListItem>
            Die angezeigten Daten sowie das Ergebnisdokument dürfen – ohne die vorherige Zustimmung des Verantwortlichen
            – vom Nutzer ausschließlich für eigene, interne Informationszwecke verwendet und insbesondere nicht an
            Dritte weitergegeben werden, gleichgültig ob eine solche Weitergabe entgeltlich oder unentgeltlich erfolgt.
          </LegalListItem>
          <LegalListItem>
            Die Plattform sowie das Ergebnisdokument enthalten Elemente und Inhalte, die zugunsten des Verantwortlichen,
            der DSS oder deren Kooperationspartner (etwa nach Urheber- /Leistungsschutzrecht, Markenrecht, Patent-
            /Gebrauchsmusterrecht, Geschmacksmusterrecht, Wettbewerbsrecht oder durch sonstige Normen) geschützt sind
            oder geschützt sein können. Der Verantwortlichen, die DSS sowie deren Kooperationspartner behalten sich
            sämtliche Rechte daran ausdrücklich vor. Die über die gewöhnliche und erforderliche Inanspruchnahme der
            Plattform durch den Nutzer hinausgehende Nutzung dieser Elemente und Inhalte (zur Gänze oder zum Teil),
            sowie insbesondere deren Vervielfältigung oder „reverse engineering“, ist ohne vorherige schriftliche
            Zustimmung des Verantwortlichen nicht gestattet. Dies gilt insbesondere, aber nicht ausschließlich, für die
            Software (mit Ausnahme allfälliger Open-Source Elemente), statistische Berechnungsmodelle, Know-How, Marken,
            Namen und Kennzeichen, Inhalt, Layout, Gestaltung und Interface der Website sowie der Plattform,
            Datenbanken, Videos, Lichtbilder, Texte sowie Grafiken. Dem Nutzer ist insbesondere nicht gestattet, die
            Plattform oder darin enthaltene Elemente für die Erstellung einer eigenen Datenbank oder ähnliche Nutzungen
            zu verwenden.
          </LegalListItem>
          <LegalListItem emphasized>
            Der Verantwortlichen übernimmt keine Gewähr oder Haftung für (i) eine bestimmte Eigenschaft, Eignung oder
            Tauglichkeit der Plattform, (ii) die ununterbrochene oder fehlerfreie Verfügbarkeit der Plattform, die
            Möglichkeit des Zugriffs oder der Interaktion, (iii) Übertragungs-, Hardware-, Software- oder
            Netzwerkfehler, (iv) verlorene, beschädigte, unvollständige, veränderte oder verspätete Übermittlung von
            Daten, (v) Angriffe oder Zugriffe durch unautorisierte Dritte innerhalb der Plattform oder von außen.
          </LegalListItem>
          <LegalListItem emphasized>
            Der Verantwortlichen übernimmt insbesondere keine Gewähr, Haftung oder Verantwortung dafür, dass die im
            Rahmen des Wohnrechners ermittelten und/oder im Ergebnisdokument enthaltenen Daten, Preise und Werte
            vollständig zutreffend sind oder tatsächlich bestimmte Kaufpreise auf dem Markt erzielt werden können. Eine
            Haftung gegenüber dem Nutzer oder Dritten im Zusammenhang mit der Verwendung der Plattform und/oder dem
            Ergebnisdokument wird ausdrücklich ausgeschlossen.
          </LegalListItem>
          <LegalListItem>
            Der Verantwortlichen behält sich das Recht vor, den Betrieb der Plattform jederzeit und ohne Vorankündigung
            zu unterbrechen oder gänzlich einzustellen. Der Nutzer kann aus einer Unterbrechung oder Einstellung
            keinerlei Rechte oder Ansprüche gegenüber dem Verantwortlichen geltend machen.
          </LegalListItem>
          <LegalListItem>
            Der Nutzer sichert zu und leistet Gewähr, dass die angegebenen Objektdaten und -informationen nicht unter
            Verletzung von geltendem Recht oder vertraglichen Bestimmungen/Beschränkungen angefertigt oder zur Verfügung
            gestellt wurden, vollständig frei von Rechten Dritter sind und durch deren Übermittlung/Zurverfügungstellung
            keine wie immer gearteten Rechte Dritter verletzt werden. Dies beinhaltet insbesondere, aber nicht
            ausschließlich, Immaterialgüterrechte, Persönlichkeitsrechte, Geheimhaltungsinteressen und Sicherungsrechte.
          </LegalListItem>
          <LegalListItem>
            Jeder Verstoß gegen die Nutzungsbedingungen kann den Ausschluss des Nutzers von der Plattform nach Ermessen
            des Verantwortlichen zur Folge haben. Ansprüche des betroffenen Nutzers gegen den Verantwortlichen infolge
            einer solchen Maßnahme sind ausgeschlossen.
          </LegalListItem>
          <LegalListItem>
            Der Verantwortliche behält sich darüber hinaus ausdrücklich vor, die personenbezogenen Daten von Nutzern,
            die gegen die Nutzungsbedingungen verstoßen, zum Zweck der Rechtsverfolgung an die DSS weiterzugeben.
            Ansprüche des betroffenen Nutzers gegen den Verantwortlichen infolge einer solchen Maßnahme sind
            ausgeschlossen.
          </LegalListItem>
          <LegalListItem>
            Diese Nutzungsbedingungen unterliegen dem Recht der Republik Österreich unter Ausschluss der
            Kollisionsnormen des Internationalen Privatrechts. Als ausschließlicher Gerichtsstand im Zusammenhang mit
            allen Rechtsstreitigkeiten, die sich direkt oder indirekt mit diesen Nutzungsbedingungen sowie der Plattform
            und deren Nutzung ergeben, wird die Zuständigkeit des Handelsgerichts Wien vereinbart. Dies gilt
            vorbehaltlich gesetzlicher Beschränkungen, insbesondere anwendbarer Verbraucherschutzbestimmungen.
          </LegalListItem>
        </LegalList>
      </LegalSection>
    </LegalPage>
  );
}
